export function filtersToString(filters: any){
    const result = `Bedrooms: ${filters['bedrooms'].toString()}, Beds: ${filters['beds'].toString()}, Pets: ${filters['pets'].toString()}`

    return result   
}